const ONES_ORDINALS = [
  "",
  "first",
  "second",
  "third",
  "fourth",
  "fifth",
  "sixth",
  "seventh",
  "eighth",
  "ninth",
];

const TEENS_ORDINALS = [
  "tenth",
  "eleventh",
  "twelfth",
  "thirteenth",
  "fourteenth",
  "fifteenth",
  "sixteenth",
  "seventeenth",
  "eighteenth",
  "nineteenth",
];

const TENS_ORDINALS = [
  "",
  "",
  "twentieth",
  "thirtieth",
  "fortieth",
  "fiftieth",
  "sixtieth",
  "seventieth",
  "eightieth",
  "ninetieth",
];

const TENS_CARDINALS = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety",
];

// Spells out an ordinal number 1-99 as words, e.g. 23 -> "twenty third".
export const spellOutOrdinal = (number) => {
  if (!Number.isInteger(number) || number < 1 || number > 99) {
    return "";
  }

  if (number < 10) {
    return ONES_ORDINALS[number];
  }

  if (number < 20) {
    return TEENS_ORDINALS[number - 10];
  }

  const tensDigit = Math.floor(number / 10);
  const onesDigit = number % 10;

  if (onesDigit === 0) {
    return TENS_ORDINALS[tensDigit];
  }

  return `${TENS_CARDINALS[tensDigit]} ${ONES_ORDINALS[onesDigit]}`;
};
